// Outline horse — matches lucide stroke style (no fill) so it sits consistently
// next to Home, Calendario, Scadenzario, Mascalcia and Terapie in the bottom nav.
// Source shape: Tabler Icons "horse" (MIT, Paweł Kuna), 24x24 stroke grid.
export default function HorseIcon({ className = "", ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
      className={className} aria-hidden="true" {...props}>
      <path d="M7 10l-.85 8.507a1.357 1.357 0 0 0 1.35 1.493h.146a2 2 0 0 0 1.857 -1.257l.994 -2.486a2 2 0 0 1 1.857 -1.257h1.292a2 2 0 0 1 1.857 1.257l.994 2.486a2 2 0 0 0 1.857 1.257h.146a1.37 1.37 0 0 0 1.364 -1.494l-.864 -9.506h-8c0 -3 -3 -5 -6 -5l-3 6l2 2l3 -2z" />
      <path d="M22 14v-2a3 3 0 0 0 -3 -3" />
    </svg>
  );
}
